import script from "./QrScanHubPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QrScanHubPage.vue?vue&type=script&setup=true&lang=js"

import "./QrScanHubPage.vue?vue&type=style&index=0&id=126b1f36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126b1f36"]])

export default __exports__